import React from "react";
import Portfolio from "./pages/portfolio/portfolio";
import { Route, Routes } from "react-router-dom";
import BiletVarmi from "./pages/biletVarmi/biletVarmi";
import Other from "./pages/other/other";
import RestaurantQRGenerator from "./pages/restorantQrGenerator/restaurantQrGenerator";

const App = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/biletvarmi" element={<BiletVarmi />} />
        <Route path="/onemlibilgi" element={<Other />} />
        <Route
          path="/restaurantqrgenerator"
          element={<RestaurantQRGenerator />}
        />
      </Routes>
    </>
  );
};

export default App;
